<template>
  <div class="main layer2" id="scroll-div-shelf" style="height: calc(100% - 2.5rem); overflow: auto;">
    <div class="search">
      <a @click="returnHome" class="return"></a>
      <strong class="title-h3">已购视频 </strong>
    </div>

    <div class="search-ls">
      <vod-list :show-title="false" :vodData="list"></vod-list>
      
    </div>
    
    <loading ref="loading" scroll-div="scroll-div-shelf" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="loadShelf(page + 1)"></loading>
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>
    <vodBottom></vodBottom>
  </div>

</template>

<script>

import vodBottom from '@/components/layer1/bottomIndex'
import userService from "../../services/userService";
import vodService from "../../services/vodService";
import VodList from '@/components/share/vod-list.vue'
import Loading from "../../components/share/loading";
import Alert from '../../components/share/alert';

export default {
  name: "shelf-vod",
  data() {
    return {
      userInfo: null,
      componentName: '',
      alertMsg: '',
      showAlert: false,
      page: 1,
      nextPage: false,
      listData: '',
      list: [],
      totalCount: 0,
      totalPage: 0,
      isLoading: false,
      isNoMoreData: false,
    }
  },
  methods: {
    returnHome() {
      this.$router.isBack = false;
      this.$router.push('/vod');
    },
    loadShelf(target) {
      this.page = target;
      if(target === 1) {
        this.list = []
      }
      this.isLoading = true;
      this.isNoMoreData = false;
      vodService.getVodShelf(this.page).then(res => {
        if (res.data){
          this.totalCount = res.data.totalCount
          this.totalPage = res.data.totalPage
          this.isLoading = false;
          if (res.data.totalPage === 0) {
            this.isNoMoreData = true;
            this.list = []
          } else if (this.page === 1) {
            this.list = res.data.list;
          } else if (this.page > 1 && this.page <= res.data.totalPage) {
            this.list.push(...res.data.list);
          }
          if (res.data.totalPage == 0 || this.page >= res.data.totalPage) {
            this.isNoMoreData = true;
          }
        }
        setTimeout(() => {
            this.$refs['loading'].scrollFunction();
          }, 0)
      });

    },
  },
  components: {
    vodBottom: vodBottom,
    loading: Loading,
    'vod-list': VodList,
    alert: Alert,
  },
  mounted() {
    this.userInfo = userService.getLocalUserInfo();
    this.componentName = this.$route.name;
    console.log(this.componentName, this.$store.state.pageState[this.componentName]);
    
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
      setTimeout(() => {
        let scrollDiv = document.getElementById('scroll-div-shelf');
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
      }, 0);
    } else {
      userService.getUserOrReg().then(res => {
        this.avaliableAmount = res.avaliableAmount
        this.loadShelf(1);
      });
    }
    this.$router.isBack = true;
  },
  beforeDestroy() {
    // let scrollDiv = document.getElementById('scroll-div-shelf');
    // let state = {};
    // state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
    // this.$store.commit('saveState', state);
  }
}
</script>
<style>
  @import '../../assets/css/search.css';
</style>
<style scoped>
.title-h3  { line-height: 40px; padding-left: .2rem; color: #fff; font-weight: 300; font-size: .8rem; height: 1.6rem; }
.search .return{ height: 1.8rem; }
.search-ls{ padding-bottom: 2rem !important;}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/shelf-vod.vue